<template>
  <div>

    <h1>Edit {{ item && item['@id'] }}</h1>
    <div class="messages"><div>
      <b-alert v-if="created" :show="dismissCountDown" dismissible variant="info" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">{{  created != null ? created['@id'] : '' }} created.</b-alert>
      <b-alert v-if="updated" :show="dismissCountDown" dismissible variant="info" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">{{  updated != null ? updated['@id'] : '' }} updated.</b-alert>
      <b-alert v-if="retrieveLoading || updateLoading || deleteLoading" dismissible>Loading...</b-alert>
      <b-alert v-if="retrieveError" dismissible variant="error"><span class="oi oi-warning" aria-hidden="true"></span> {{ retrieveError }}</b-alert>
      <b-alert v-if="updateError" dismissible variant="error"><span class="oi oi-warning" aria-hidden="true"></span> {{ updateError }}</b-alert>
      <b-alert v-if="deleteError" dismissible variant="error"><span class="oi oi-warning" aria-hidden="true"></span> {{ deleteError }}</b-alert>
    </div></div>
    <OrganizationForm v-if="item" :handle-submit="update" :values="item" :errors="violations" :initialValues="retrieved"></OrganizationForm>
    <footer class="footer fixed-bottom bn-footer">
      <div style="float:right">
        <router-link v-if="item" :to="{ name: 'OrganizationList' }" class="btn btn-primary btn-sm">Back to list</router-link>
        <button @click="del" class="btn btn-danger btn-sm">Delete</button>
      </div>
    </footer>
  </div>
</template>



<script>
  import OrganizationForm from './Form.vue';
  import { mapGetters } from 'vuex';
  import { Alert } from 'bootstrap-vue/es/components';




  export default {
    created () {
      this.$store.dispatch('organization/update/retrieve', decodeURIComponent(this.$route.params.id));
    },
    components: {
      OrganizationForm,
        'alert': Alert
    },
    computed: {
      ...mapGetters({
        retrieveError: 'organization/update/retrieveError',
        retrieveLoading: 'organization/update/retrieveLoading',
        updateError: 'organization/update/updateError',
        updateLoading: 'organization/update/updateLoading',
        deleteError: 'organization/del/error',
        deleteLoading: 'organization/del/loading',
        created: 'organization/create/created',
        deleted: 'organization/del/deleted',
        retrieved: 'organization/update/retrieved',
        updated: 'organization/update/updated',
        violations: 'organization/update/violations'
      })
    },
    data: function() {
      return {
          dismissSecs: 5,
          dismissCountDown: 0,
          showDismissibleAlert: false,
          item: {}
      }
    },

    methods: {
      update (values) {
        this.$store.dispatch('organization/update/update', {item: this.retrieved, values: values });
          this.dismissCountDown = this.dismissSecs;
          console.log(this.dismissCountDown);
      },
      del () {
        if (window.confirm('Are you sure you want to delete this item?')) {
            this.$store.dispatch('organization/del/delete', this.retrieved);
            this.dismissCountDown = this.dismissSecs;
        }
      },
      reset () {
        this.$store.dispatch('organization/update/reset');
        this.$store.dispatch('organization/del/reset');
        this.$store.dispatch('organization/create/reset');
        this.dismissCountDown = this.dismissSecs;

      },
        countDownChanged (dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        showAlert () {
            this.dismissCountDown = this.dismissSecs
        }

    },
    watch: {
      deleted: function (deleted) {
        if (deleted) {
          this.$router.push({ name: 'OrganizationList' });
        }
      }
    },
    beforeDestroy() {
      this.reset();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/organization/Update.vue